import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Analyse } from 'src/app/domain/Analyse/analyse';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { Router, ActivatedRoute } from '@angular/router';
import { AnalyseStatut } from 'src/app/domain/Analyse/enum/analyse-statut';
import { AnalyseService } from 'src/app/services/analyse-service';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { CoreData } from 'src/app/tools/core-data';
import { InterventionService } from 'src/app/services/intervention.services';
import { SampleCodeBoxComponent } from 'src/app/tools/ui/cyano-creation-box/sample-code-box.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationManager } from 'src/app/tools/notification-manager';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InterventionCreateDTO } from 'src/app/services/DTO/intervention.dto';

@Component({
    selector: 'app-analysis-list',
    templateUrl: './analysis-list.component.html',
    styleUrls: ['./analysis-list.component.scss']
})
export class AnalysisListComponent implements OnInit, AfterContentInit {
    public AnalysisList: Analyse[] = [];
    public SearchText: string;

    constructor(
        public coreData: CoreData,
        private router: Router,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute,
        private analysisService: AnalyseService,
        private interventionService: InterventionService) { }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        if (this.coreData.IsOffline) {
            if (this.coreData.getLocalAnalyseList().length > 0) {
                this.coreData.getLocalAnalyseList().forEach(i => {
                    this.AnalysisList.push(this.coreData.getOfflineAnalyse(i));
                });
            }
        } else {
            this.searchAnalysisList();
        }

        this.coreData.CurrentPageName = "";
    }

    searchAnalysisList(status?: AnalyseStatut) {
        this.analysisService.getAnalysisListByStatus(status).subscribe(x => {
            this.AnalysisList = x;
        });
    }

    searchBySampleCode() {
        this.analysisService.getAnalyseBySampleCode(this.SearchText).subscribe(x => {
            this.SearchText = '';
            this.AnalysisList = [];
            this.AnalysisList.push(x);
        });
    }

    getAnalysisStatusName(status: AnalyseStatut) {
        return StringConverter.getAnalysisStatusName(status);
    }

    getColorByInterventionStatus(type: EInterventionType) {
        switch (type) {
            case EInterventionType.IBD:
                return '#F5822B !important';
            case EInterventionType.IBGN:
                return '#FFDD4A !important';
            case EInterventionType.MPCE:
                return '#3AB795 !important';
            case EInterventionType.EAU:
                return 'aqua !important';
            case EInterventionType.LAC:
                return 'cornflowerblue !important';
            case EInterventionType.IBMR:
                return 'olivedrab !important';
            case EInterventionType.MGCE:
                return 'navy !important';
            case EInterventionType.Cyano:
                return 'pink !important';
            case EInterventionType.IML:
                return '#bda676 !important';
        }
    }

    getTextColorByInterventionStatus(type: EInterventionType) {
        switch (type) {
            case EInterventionType.IBD:
            case EInterventionType.IBGN:
            case EInterventionType.MPCE:
            case EInterventionType.EAU:
            case EInterventionType.LAC:
            case EInterventionType.IBMR:
            case EInterventionType.IML:
                return 'black !important';
            case EInterventionType.MGCE:
                return 'white !important';
        }
    }

    getInterventionLabel(int: Analyse) {
        return StringConverter.getInterventionTypeName(int.Type)
    }

    navigateToAnalysis(analysis: Analyse) {
        if (analysis.Code === undefined || analysis.Code === '') {
            return;
        }
        this.coreData.CurrentPageName = analysis.SampleCode;

        if (analysis.Type === EInterventionType.IBMR)
            this.router.navigate([ENavigationRoute.AnalyseIBMR, { interventionCode: analysis.InterventionCode }]);
        else if (analysis.Type === EInterventionType.Cyano)
            this.router.navigate([ENavigationRoute.AnalyseCyano, { analyseCode: analysis.Code }]);
        else
            this.router.navigate([ENavigationRoute.Analyse, { interventionCode: analysis.InterventionCode }]);
    }

    navigateToNotation(analysis: Analyse) {
        this.router.navigate([ENavigationRoute.Notation, { code: analysis.Code }]);
    }

    openCyanoCreationBox() {

        const dialogRef = this.dialog.open(SampleCodeBoxComponent, {
            data: 'Ajout d\'une intervention Cyano',
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.createNewAnalyseForCyano(result);
            }
        });
    }

    createNewAnalyseForCyano(sampleCode: string) {
        const dto = new InterventionCreateDTO();
        dto.Type = EInterventionType.Cyano;
        dto.SampleCode = sampleCode;
        this.interventionService.createIntervention(dto).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Analyse ajouté', this.snackBar);
                this.searchAnalysisList();
            }
        })
    }

}
